import React, { useState, useEffect, useRef, useContext } from "react";
import { UserContext } from "../context/UserProvider";
import Swal from 'sweetalert2'

const ChatInput = ({ onSend, onReset }) => {
    const [message, setMessage] = useState("");
    const { user } = useContext(UserContext)

    const handleSend = () => {
        if (message.trim() !== "") {
            onSend(message);
            setMessage("");
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            handleSend();
        }
    };

    return (
        <div style={styles.container}>
            <textarea
                style={styles.textarea}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                onKeyDown={handleKeyPress}
                placeholder="Escribe tu mensaje..."
                rows={1}
            />
            <button style={styles.button} onClick={handleSend}>
                Enviar
            </button>
            <button style={styles.buttonreinicio} onClick={onReset}>
                Reiniciar
            </button>
        </div>
    );
};

const Chat = (props) => {
    const [messages, setMessages] = useState([]);
    const messagesEndRef = useRef(null);
    const [pendientes, setpendientes] = useState([]);
    const [todaslasempresas, settodaslasempresas] = useState([]);
    const { user } = useContext(UserContext)
    const [fechahoy, setfechahoy] = useState(new Date().getFullYear() + "-" + ("0" + (new Date().getMonth() + 1)).slice(-2) + "-" + ("0" + new Date().getDate()).slice(-2));
    const [fechahoyconslash, setfechahoyconslash] = useState(() => {
        const now = new Date();

        const dia = ("0" + now.getDate()).slice(-2);
        const mes = ("0" + (now.getMonth() + 1)).slice(-2); // Meses comienzan desde 0
        const anio = now.getFullYear();

        const horas = ("0" + now.getHours()).slice(-2);
        const minutos = ("0" + now.getMinutes()).slice(-2);
        const segundos = ("0" + now.getSeconds()).slice(-2);

        return `${mes}/${dia}/${anio} ${horas}:${minutos}:${segundos}`;
    });
    const [hora, sethora] = useState(() => {
        const now = new Date();

        const dia = ("0" + now.getDate()).slice(-2);
        const mes = ("0" + (now.getMonth() + 1)).slice(-2); // Meses comienzan desde 0
        const anio = now.getFullYear();

        const horas = ("0" + now.getHours()).slice(-2);
        const minutos = ("0" + now.getMinutes()).slice(-2);
        const segundos = ("0" + now.getSeconds()).slice(-2);

        return `${horas}:${minutos}:${segundos}`;
    });
    const [fechahoyconslashsinhora, setfechahoyconslashsinhora] = useState(() => {
        const now = new Date();

        const dia = ("0" + now.getDate()).slice(-2);
        const mes = ("0" + (now.getMonth() + 1)).slice(-2); // Meses comienzan desde 0
        const anio = now.getFullYear();

        const horas = ("0" + now.getHours()).slice(-2);
        const minutos = ("0" + now.getMinutes()).slice(-2);
        const segundos = ("0" + now.getSeconds()).slice(-2);

        return `${mes}/${dia}/${anio}`;
    });
    const [anioActual, setAnioActual] = useState(new Date().getFullYear());
    const [nombreMes, setNombreMes] = useState(() => {
        const nombresMeses = [
            "enero", "febrero", "marzo", "abril", "mayo", "junio",
            "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
        ];
        return nombresMeses[new Date().getMonth()]; // Mes actual
    });
    const handleSend = async (message) => {
        const currentDate = new Date();
        const currentHour = currentDate.getHours();
        let dt = JSON.parse(user)

        var bot = ""
        var mmm = (prevMessages) => [
            ...prevMessages,
            { text: message, type: "user" },
            { text: bot, type: "auto" },
        ]
        setMessages(mmm);
        hablarconjerry(messages, message)
    };
    const hablarconjerry = async (listamensajes, message) => {
        const currentDate = new Date();
        const currentHour = currentDate.getHours();
        let dt = JSON.parse(user)

        const url = props.servidor + '/ChatgptApi?llave=' + dt.usuario.llaveempresa;
        var solicitud = {
            instruccion: message,
            datos: props.ventas,
            mensajesjerryviejos: listamensajes,
            promt:props.promt
        }
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            },
            body: JSON.stringify(solicitud),
        };

        try {
            const response = await fetch(url, requestOptions);

            if (response.ok) {
                const dataJson = await response.json();
                var resppp=dataJson[dataJson.length-1].content[0].text
                console.log("Respuesta de la IA:",dataJson );
                var bot=""
                setMessages((prevMessages) => [
                    ...prevMessages,
                    { text: message, type: "user" },
                    { text: resppp, type: "auto" },
                ]);
            } else {
                const error = await response.text();
                Swal.fire(
                    'Oops!',
                    'Error al consultar IA: ' + error,
                    'error'
                );
            }
        } catch (error) {
            console.error("Error en la solicitud:", error);
        }

    };

    useEffect(() => {

    }, [])

    useEffect(() => {
        if (messagesEndRef.current) {
            messagesEndRef.current.scrollTop = messagesEndRef.current.scrollHeight;
        }
    }, [messages]);
    return (
        <div style={styles.chatContainer}>

            <div style={styles.messagesContainer} ref={messagesEndRef} >
                {messages.map((msg, index) => (
                    <div
                        key={index}
                        style={{
                            ...styles.message,
                            alignSelf: msg.type === "user" ? "flex-end" : "flex-start",
                            backgroundColor: msg.type === "auto" ? "#ffd1d1" : "#e9f5ff",
                        }}
                    >
                        {msg.text}
                    </div>
                ))}
                {/* <div ref={messagesEndRef} /> */}
            </div>
            <ChatInput onSend={handleSend} onReset={() => {

            }} />
        </div>
    );
};

const styles = {
    container: {
        display: "flex",
        alignItems: "center",
        gap: "10px",
        padding: "10px",
        backgroundColor: "#f5f5f5",
        borderTop: "1px solid #ddd",
    },
    textarea: {
        flex: 1,
        padding: "10px",
        fontSize: "16px",
        borderRadius: "8px",
        border: "1px solid #ddd",
        outline: "none",
        resize: "none",
        overflow: "hidden",
        boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1)",
    },
    button: {
        backgroundColor: "#007bff",
        color: "white",
        padding: "10px 20px",
        fontSize: "16px",
        borderRadius: "8px",
        border: "none",
        cursor: "pointer",
        transition: "background-color 0.3s",
    },
    buttonreinicio: {
        backgroundColor: "red",
        color: "white",
        padding: "10px 20px",
        fontSize: "16px",
        borderRadius: "8px",
        border: "none",
        cursor: "pointer",
        transition: "background-color 0.3s",
    },
    chatContainer: {
        display: "flex",
        flexDirection: "column",
        height: "80vh",
        maxWidth: "600px",
        margin: "0 auto",
        border: "1px solid #ddd",
        borderRadius: "8px",
        overflow: "hidden",
    },
    messagesContainer: {
        flex: 1,
        padding: "10px",
        overflowY: "auto", // Habilita el scroll vertical
        backgroundColor: "#ffffff",
        display: "flex",
        flexDirection: "column",
        gap: "5px",
        whiteSpace: "pre-wrap",
        maxHeight: "400px", // Limita la altura del contenedor
        border: "1px solid #ddd", // (Opcional) para visualizar los límites del contenedor
        borderRadius: "8px", // (Opcional) para un diseño más moderno
    },
    message: {
        padding: "10px",
        margin: "5px 0",
        borderRadius: "8px",
        boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1)",
        maxWidth: "70%",
        backgroundColor: "#f9f9f9", // (Opcional) un color para contrastar con el fondo del contenedor
        wordBreak: "break-word", // Permite que los mensajes largos se ajusten a la línea
    },
};

export default Chat;

